import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
// import moment from "moment";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const getAllShippingMovements = createAsyncThunk(
  "ShippingMovements/FindAllShippingMovements",
  async (ShippingMovementsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ShippingMovements/FindAllShippingMovements`,
        ShippingMovementsData
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Shipping Movements:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createShippingMovements = createAsyncThunk(
  "ShippingMovements/InsertShippingMovements",
  async (ShippingMovementsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ShippingMovements/InsertShippingMovements`,
        ShippingMovementsData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Shipping Movement:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateShippingMovements = createAsyncThunk(
  "ShippingMovements/UpdateShippingMovements",
  async (ShippingMovementsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ShippingMovements/UpdateShippingMovements`,
        ShippingMovementsData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Shipping Movement:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteShippingMovements = createAsyncThunk(
  "ShippingMovements/DeleteShippingMovements",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ShippingMovements/DeleteShippingMovements`,
        { shipping_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Shipping Movement:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getShippingMovementsByID = createAsyncThunk(
  "ShippingMovements/FindByIDShippingMovements",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/ShippingMovements/FindByIDShippingMovements`,
        { shipping_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        // form_type:result.form_type,
        id: result?.id,
        shipping_guid: result?.shipping_guid,
        shipping_movements: result?.shipping_movements,
        port_id: result?.port_id,
        eta: result?.eta ? moment(result?.eta, "YYYY-MM-DD").toDate() : "",
        cut_off_datetime: result?.cut_off_datetime
          ? moment(result?.cut_off_datetime, "YYYY-MM-DD").toDate()
          : "",
        cut_off_time: result?.cut_off_time
          ? moment(result?.cut_off_time, "HH:mm:ss").toDate()
          : "",
        vessels_name: result?.vessels_name,
        voj_no: result?.voj_no,
        vcn: result?.vcn,
        line_id: result?.line_id ? result?.line_id.split(",").map(Number) : [],
        agent_id: result?.agent_id
          ? result?.agent_id.split(",").map(Number)
          : [],
        will_load_for: result?.will_load_for,
        etd: result?.etd ? moment(result?.etd, "YYYY-MM-DD").toDate() : "",
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Shipping Movement:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
